export default "__VITE_ASSET__DiEwULz4__"